module.exports = __webpack_public_path__ + "img/img-pegasus-d.b0876eca.png";